import { ReactElement } from "react";

import Error404 from "components/Error/404";

function Page404(): ReactElement {
  return <Error404 className="my-12" />;
}

export default Page404;
